const burger = () => {
	const burgerOpen = document.querySelector('.js-burger-open');
	const burgerClose = document.querySelector('.js-burger-close');
	const body = document.body;
	const header = document.querySelector('.header');
	const headerMob = document.querySelector('.header-mob');

	if (!burgerOpen || !burgerClose || !header) return;

	const openMenu = () => {
		body.classList.add('is-hidden');
		header.classList.add('is-open');
	};

	const closeMenu = () => {
		body.classList.remove('is-hidden');
		header.classList.remove('is-open');
	};

	burgerOpen.addEventListener('click', openMenu);
	burgerClose.addEventListener('click', closeMenu);

	if (headerMob) {
		const menuItems = headerMob.querySelectorAll('.header-mob__list li');
		menuItems.forEach(item => {
			item.addEventListener('click', closeMenu);
		});

		const btn = headerMob.querySelector('.btn');
		if (btn) {
			btn.addEventListener('click', closeMenu);
		}
	}
};

export default burger;